/* MECAB — scripts du thème (style e-commerce mobile) */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Menu mobile */
  $$('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = $('#drawer'); if (!d) return;
      d.classList.add('is-open'); document.body.style.overflow = 'hidden'; b.setAttribute('aria-expanded', 'true');
      var c = $('[data-drawer-close]', d); if (c) c.focus();
    });
  });
  function closeDrawer() {
    var d = $('#drawer'); if (d) d.classList.remove('is-open'); document.body.style.overflow = '';
    $$('[data-drawer-open]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
  }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }

  /* Fiche produit */
  $$('[data-product]').forEach(function (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var extra = JSON.parse($('[data-variant-extra]', root).textContent);
    var form = $('form[data-product-form]', root);
    var idInput = $('input[name="id"]', form);
    var addBtn = $('[data-add]', root), buyBtn = $('[data-buy]', root);
    var sticky = $('[data-sticky]', root);
    var err = $('[data-opt-error]', root);
    var lowStock = parseInt(root.getAttribute('data-low-stock') || '5', 10);
    var current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];

    function selected() {
      return data.options.map(function (_, i) {
        var s = $('select[data-opt="' + i + '"]', root); if (s) return s.value || null;
        var c = $('input[data-opt="' + i + '"]:checked', root); return c ? c.value : null;
      });
    }
    function complete() { return selected().every(Boolean); }
    function match(sel) { return data.variants.find(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); }); }

    function render() {
      var x = extra[String(current.id)] || {};
      var sel = selected();
      idInput.value = current.id;
      $$('[data-price-now]', root).forEach(function (el) { el.textContent = x.price; });
      $$('[data-price-was]', root).forEach(function (el) { el.textContent = x.compare || ''; el.hidden = !x.compare; });
      $$('[data-price-box]', root).forEach(function (el) { el.classList.toggle('is-sale', !!x.compare); });
      var pct = $('[data-pct]', root); if (pct) { pct.textContent = x.pct ? '−' + x.pct + ' %' : ''; pct.hidden = !x.pct; }
      $$('[data-opt-value]', root).forEach(function (el) { el.textContent = sel[parseInt(el.getAttribute('data-opt-value'), 10)] || ''; });
      var stock = $('[data-stock]', root);
      if (stock) {
        if (complete() && !current.available) { stock.textContent = 'Épuisé dans cette taille'; stock.hidden = false; }
        else if (complete() && x.tracked && x.qty > 0 && x.qty <= lowStock) { stock.innerHTML = '<span class="badge badge--destock">Ça part vite</span> Plus que ' + x.qty + ' pièce' + (x.qty > 1 ? 's' : ''); stock.hidden = false; }
        else stock.hidden = true;
      }
      var ok = !complete() || current.available;
      [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
      if (buyBtn) buyBtn.textContent = ok ? buyBtn.getAttribute('data-label') : 'Épuisé';
      var tot = $('[data-total]', root); if (tot && x.tot) tot.textContent = x.tot[0];
      var tn = $('[data-total-note]', root); if (tn) tn.textContent = tn.getAttribute(x.free ? 'data-free' : 'data-paid');
      var sl = sticky && $('[data-sticky-line]', sticky); if (sl) sl.textContent = sel.filter(Boolean).join(' · ') || data.title;
      /* tailles épuisées pour la couleur choisie */
      /* carreaux de taille : barrés si épuisés pour la couleur choisie */
      $$('[data-size-group] input[data-opt]', root).forEach(function (inp) {
        var i = parseInt(inp.getAttribute('data-opt'), 10);
        var t = sel.slice(); t[i] = inp.value;
        var known = t.every(Boolean);
        var v = known ? match(t) : null;
        var out = known && (!v || !v.available);
        inp.disabled = !!out;
        if (inp.nextElementSibling) inp.nextElementSibling.classList.toggle('is-out', !!out);
        if (out && inp.checked) inp.checked = false;
      });
      if (current.featured_media) {
        var fig = $('[data-media-id="' + current.featured_media.id + '"]', root);
        var gal = fig && fig.parentNode;
        if (gal && gal.scrollWidth <= gal.clientWidth) { if (gal.firstElementChild !== fig) gal.insertBefore(fig, gal.firstElementChild); } else if (gal) gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
      }
    }
    $$('[data-opt]', root).forEach(function (el) {
      el.addEventListener('change', function () {
        if (err) err.hidden = true;
        var sel = selected();
        if (sel.every(Boolean)) {
          var v = match(sel);
          if (v) { current = v; if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id); }
        } else {
          /* couleur changée sans taille : on montre la 1re variante dispo de cette couleur */
          var v2 = data.variants.find(function (v) { return v.options.every(function (o, k) { return !sel[k] || o === sel[k]; }) && v.available; });
          if (v2) current = v2;
        }
        render();
      });
    });

    function needChoice() {
      if (complete()) return false;
      if (err) err.hidden = false;
      var g = $('[data-size-group]', root);
      if (g) { g.scrollIntoView({ block: 'center', behavior: 'smooth' }); g.classList.remove('shake'); void g.offsetWidth; g.classList.add('shake'); var first = $('input:not(:disabled)', g); if (first) first.focus({ preventScroll: true }); }
      return true;
    }
    function add(then) {
      return fetch(window.MECAB.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch(window.MECAB.routes.cart_js); })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); then(); })
        .catch(function () { form.submit(); });
    }
    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault(); if (needChoice()) return; addBtn.disabled = true;
      add(function () { addBtn.disabled = false; addBtn.textContent = 'Ajouté au panier ✓'; setTimeout(function () { addBtn.textContent = addBtn.getAttribute('data-label'); }, 1800); });
    });
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault(); if (needChoice()) return; buyBtn.disabled = true;
      add(function () { location.href = '/checkout'; });
    });
    form.addEventListener('submit', function (e) { if (!complete()) { e.preventDefault(); needChoice(); } });

    /* points de la galerie */
    var gal = $('.gal', root), dots = $$('.gal-dots span', root);
    if (gal && dots.length) gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });

    if (sticky) {
      var target = $('[data-buy-zone]', root);
      $('[data-sticky-go]', sticky).addEventListener('click', function () {
        if (!complete()) { needChoice(); return; }
        (buyBtn || addBtn).click();
      });
      if ('IntersectionObserver' in window && target) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); document.body.classList.toggle('has-sticky', sticky.classList.contains('is-on')); }).observe(target);
      }
    }
    render();
  });

  /* « Complète ton look » */
  $$('[data-recos]').forEach(function (el) {
    if (!el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recos]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.closest('section').hidden = true;
    }).catch(function () {});
  });

  /* Tri */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
  });

  /* « Charger plus » */
  $$('[data-load-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-next'); if (!url) return;
      btn.disabled = true; btn.textContent = 'Chargement…';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var grid = $('[data-coll-grid]'), next = d.querySelector('[data-coll-grid]');
        if (grid && next) Array.prototype.forEach.call(next.children, function (c) { grid.appendChild(c.cloneNode(true)); });
        var nb = d.querySelector('[data-load-more]');
        var shown = $('[data-shown]'); if (shown && grid) shown.textContent = grid.children.length;
        if (nb && nb.getAttribute('data-next')) { btn.setAttribute('data-next', nb.getAttribute('data-next')); btn.disabled = false; btn.textContent = 'Charger plus'; }
        else btn.parentNode.hidden = true;
      }).catch(function () { location.href = url; });
    });
  });
})();

/* Suivre ma commande : prépare un message WhatsApp */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-track]'), function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var o = (f.elements.order.value || '').trim(), ph = (f.elements.phone.value || '').trim();
      var err = f.querySelector('[data-track-err]');
      if (!ph) { if (err) err.hidden = false; f.elements.phone.focus(); return; }
      if (err) err.hidden = true;
      var msg = 'Salam MECAB, je veux suivre ma commande' + (o ? ' n° ' + o : '') + '. Mon téléphone : ' + ph;
      window.open('https://wa.me/' + f.getAttribute('data-wa') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
  });
})();

/* Panier : changer la quantité met à jour le total tout de suite */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-cart-line]'), function (box) {
    var input = box.querySelector('input');
    function send(q) {
      q = Math.max(0, Math.min(10, q));
      box.classList.add('is-busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(box.getAttribute('data-cart-line'), 10), quantity: q }) })
        .then(function () { location.reload(); })
        .catch(function () { box.classList.remove('is-busy'); });
    }
    Array.prototype.forEach.call(box.querySelectorAll('[data-cart-step]'), function (b) {
      b.addEventListener('click', function () { send((parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-cart-step'), 10)); });
    });
    input.addEventListener('change', function () { send(parseInt(input.value, 10) || 0); });
  });
})();

/* Panier : ajouter un basique en un clic sur la taille */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-up-add]'), function (b) {
    b.addEventListener('click', function () {
      b.classList.add('is-busy'); b.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-up-add'), 10), quantity: 1 }] }) })
        .then(function () { location.reload(); })
        .catch(function () { b.classList.remove('is-busy'); b.disabled = false; });
    });
  });
})();

/* Trouve ta taille · اعرف تايلك */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-fit]'), function (fit) {
    var root = fit.closest('[data-product]') || document;
    var cfg = {};
    try { cfg = JSON.parse(fit.querySelector('[data-fit-data]').textContent); } catch (e) {}
    var cols = (cfg.cols || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    function range(t) { var m = String(t || '').match(/(\d+)\s*[-–à]\s*(\d+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
    var rows = String(cfg.rows || '').split(/\n/).map(function (l) {
      var p = l.split(';').map(function (x) { return x.trim(); });
      if (!p[0]) return null;
      return { size: p[0], h: range(p[1]), w: range(p[2]), m: p.slice(3).filter(function (x) { return x !== ''; }) };
    }).filter(Boolean);
    /* tableau */
    var tbl = fit.querySelector('[data-fit-table]');
    var head = '<thead><tr><th>Taille</th><th>Ta taille</th><th>Ton poids</th>' + cols.map(function (c) { return '<th>' + c + '</th>'; }).join('') + '</tr></thead>';
    var body = '<tbody>' + rows.map(function (r) {
      return '<tr data-size="' + r.size + '"><th>' + r.size + '</th><td>' + (r.h ? r.h[0] + '–' + r.h[1] + ' cm' : '—') + '</td><td>' + (r.w ? r.w[0] + '–' + r.w[1] + ' kg' : '—') + '</td>' +
        cols.map(function (_, i) { return '<td>' + (r.m[i] || '—') + '</td>'; }).join('') + '</tr>';
    }).join('') + '</tbody>';
    tbl.innerHTML = head + body;

    var opener = root.querySelector('[data-fit-open]'), lastFocus = null;
    function open() { lastFocus = document.activeElement; fit.hidden = false; document.body.style.overflow = 'hidden'; var i = fit.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 50); }
    function close() { fit.hidden = true; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    if (opener) opener.addEventListener('click', open);
    Array.prototype.forEach.call(fit.querySelectorAll('[data-fit-close]'), function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !fit.hidden) close(); });

    /* conseil : poids d'abord, puis taille ; entre deux, la plus grande */
    function recommend(h, w) {
      var best = null, bestScore = Infinity;
      rows.forEach(function (r, i) {
        var s = 0;
        if (r.w) s += w < r.w[0] ? (r.w[0] - w) * 1.4 : w > r.w[1] ? (w - r.w[1]) * 1.4 : 0;
        if (r.h) s += h < r.h[0] ? (r.h[0] - h) : h > r.h[1] ? (h - r.h[1]) : 0;
        s -= i * 0.001; /* égalité : la plus grande */
        if (s < bestScore) { bestScore = s; best = r; }
      });
      var exact = best && best.w && best.h && w >= best.w[0] && w <= best.w[1] && h >= best.h[0] && h <= best.h[1];
      return { row: best, exact: exact };
    }
    var res = fit.querySelector('[data-fit-res]'), err = fit.querySelector('[data-fit-err]'), chosen = null;
    fit.querySelector('[data-fit-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var h = parseFloat(this.elements.h.value), w = parseFloat(this.elements.w.value);
      if (!h || !w) { err.hidden = false; res.hidden = true; return; }
      err.hidden = true;
      var r = recommend(h, w); if (!r.row) return;
      chosen = r.row.size;
      fit.querySelector('[data-fit-size]').textContent = chosen;
      fit.querySelector('[data-fit-note]').textContent = r.exact ? 'Pour ' + h + ' cm et ' + w + ' kg.' : 'Taille la plus proche pour ' + h + ' cm et ' + w + ' kg. Un doute ? Écris-nous sur WhatsApp.';
      Array.prototype.forEach.call(tbl.querySelectorAll('tr[data-size]'), function (tr) { tr.classList.toggle('is-on', tr.getAttribute('data-size') === chosen); });
      var inp = root.querySelector('[data-size-group] input[value="' + chosen + '"]');
      var pick = fit.querySelector('[data-fit-pick]');
      if (inp && inp.disabled) { pick.disabled = true; pick.textContent = 'Épuisé dans cette couleur'; }
      else { pick.disabled = false; pick.textContent = 'Choisir la taille ' + chosen; }
      res.hidden = false;
    });
    fit.querySelector('[data-fit-pick]').addEventListener('click', function () {
      var inp = chosen && root.querySelector('[data-size-group] input[value="' + chosen + '"]');
      if (inp && !inp.disabled) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      close();
    });
  });
})();

/* Point vert « joignable » pour le téléphone pendant les horaires (heure de Tunis) */
(function () {
  var els = document.querySelectorAll('[data-open-hours]');
  if (!els.length) return;
  var h;
  try { h = parseInt(new Intl.DateTimeFormat('fr-FR', { hour: 'numeric', hour12: false, timeZone: 'Africa/Tunis' }).format(new Date()), 10); }
  catch (e) { h = new Date().getHours(); }
  els.forEach(function (el) {
    var m = (el.getAttribute('data-open-hours') || '').match(/(\d{1,2})\D+(\d{1,2})/);
    if (m && h >= +m[1] && h < +m[2]) el.classList.add('is-open');
  });
})();
